document.addEventListener("DOMContentLoaded", function(event) {
    
    const elementos = document.querySelectorAll('.image-with-text__media');

    elementos.forEach(elemento => {
        
        elemento.addEventListener('click', () => {
            if (elemento.getAttribute('data-video-url') && !elemento.querySelector('video')) {
                const imagen = elemento.querySelector('img');
                imagen.style.display = 'none';

                const videoURL = elemento.getAttribute('data-video-url');
                const video = document.createElement('video');
                video.src = videoURL;
                video.setAttribute('srcset', videoURL);
                video.setAttribute('controls', '');
                video.setAttribute('playsinline', '');

                elemento.appendChild(video);

                video.play();

                elemento.removeAttribute('data-video-url');
            }
        });
    });
});